import { tw } from '@/lib/utils'

// Loading placeholder shaped like a real featured-products card. The parent
// overlays it (`absolute inset-0`) on the real, visually hidden card, so it
// inherits that card's exact box — the image area keeps its fixed aspect and the
// text area flexes to fill the rest, matching the loaded card's height whether
// the product name wraps to one line or two (no CLS, no row shift on reveal).
// Non-text, so no i18n; aria-hidden.
//
// `featured` mirrors the staff-pick card (dark, image on top, overlapping body);
// `list` mirrors the smaller horizontal list cards.
export const FeaturedProductSkeleton = ({
  variant,
  className,
}: {
  variant: 'featured' | 'list'
  className?: string
}) => {
  if (variant === 'featured') {
    return (
      <div aria-hidden className={tw('flex flex-col overflow-hidden rounded-2xl bg-[#142546] shadow-lg', className)}>
        <div className="aspect-[16/10] w-full shrink-0 animate-pulse bg-white/5" />
        <div className="-mt-12 flex flex-1 flex-col gap-3 p-5">
          <div className="h-4 w-20 animate-pulse rounded bg-white/10" />
          <div className="h-6 w-3/4 animate-pulse rounded bg-white/10" />
          <div className="mt-auto flex items-center justify-between border-t border-white/10 pt-3">
            <div className="h-6 w-24 animate-pulse rounded bg-white/10" />
            <div className="h-5 w-5 animate-pulse rounded bg-white/10" />
          </div>
        </div>
      </div>
    )
  }

  return (
    <div aria-hidden className={tw('flex gap-4 rounded-xl border border-slate-100 bg-white p-4 shadow-sm', className)}>
      <div className="bg-navy-10 h-24 w-24 shrink-0 animate-pulse rounded-lg" />
      <div className="flex min-w-0 flex-1 flex-col gap-2 pt-1">
        <div className="bg-navy-10 h-3 w-16 animate-pulse rounded" />
        <div className="bg-navy-10 h-5 w-3/4 animate-pulse rounded" />
        <div className="bg-navy-10 h-4 w-1/3 animate-pulse rounded" />
        <div className="bg-navy-10 mt-auto ml-auto h-7 w-12 animate-pulse rounded" />
      </div>
    </div>
  )
}
